import React, { useMemo } from 'react';
import ChatBlockTable from '@/components/ChatBlockTable';
import ChatBlockChart from '@/components/ChatBlockChart';
import ChatMarkdownBody from '@/components/ChatMarkdownBody';
import ChatMessageBlocks from '@/components/ChatMessageBlocks';
import { hasMeetingPrepBlocks, interleaveMeetingPrepContent } from '@/lib/meetingPrepBlocks';

function renderBlock(block) {
  if (block?.type === 'table') return <ChatBlockTable key={block.id} block={block} />;
  if (block?.type === 'chart') return <ChatBlockChart key={block.id} block={block} />;
  return null;
}

export default function ChatAnswerWithBlocks({ text, blocks, sender, linkRegistry, people }) {
  const interleaved = useMemo(() => {
    if (!hasMeetingPrepBlocks(blocks)) return null;
    return interleaveMeetingPrepContent(text, blocks);
  }, [text, blocks]);

  if (interleaved) {
    return (
      <div className="space-y-4">
        {interleaved.map((part, index) => {
          if (part.type === 'block') return renderBlock(part.block);
          if (!String(part.text || '').trim()) return null;
          return (
            <ChatMarkdownBody
              key={`md-${index}`}
              text={part.text}
              sender={sender}
              linkRegistry={linkRegistry}
              people={people}
            />
          );
        })}
      </div>
    );
  }

  return (
    <>
      <ChatMessageBlocks blocks={blocks} />
      <ChatMarkdownBody
        text={text}
        sender={sender}
        linkRegistry={linkRegistry}
        people={people}
      />
    </>
  );
}
